import { useState } from "react";
import { Button } from "../../Button";
import _ from "lodash";
import { tMsg } from "../../ToastNotifications";

export const TextInputForStringArray = ({
  addValueFunction,
}: {
  addValueFunction: (val: string) => void;
}) => {
  const [inputVal, setInputVal] = useState<string>("");
  const modifyInput = (val: string) => {
    if (val.includes('"'))
      tMsg.warning('Cannot include double quotes " for this field');
    else setInputVal(val);
  };
  return (
    <div className="flex gap-3">
      <input
        value={inputVal}
        className="w-full border border-[#ccc] p-2.5 text-sm"
        placeholder="Type to add..."
        onChange={(e) => {
          e.preventDefault();
          modifyInput(e.target.value);
        }}
      />
      <Button
        onClick={(e) => {
          e.preventDefault();
          const temp = inputVal;
          addValueFunction(temp);
          setInputVal("");
        }}
        disabled={inputVal.length < 1}
      >
        Add
      </Button>
    </div>
  );
};

export const StringArrayItem = ({
  name,
  ...restProps
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { name: string }) => {
  return (
    <div className="flex gap-[1px] w-full">
      <div className="grid content-center w-full bg-grayBg px-3 py-0.5 text-sm">
        {name}
      </div>
      <button
        {...restProps}
        className="bg-grayBg px-2 py-0.5 text-white hover:bg-darkGrayBg"
      >
        <i className="icon-close text-xs" />
      </button>
    </div>
  );
};
